import ProgressBar from 'react-bootstrap/esm/ProgressBar';

function LoadingIndicator() {
  return (
    <ProgressBar animated now={100} className="mb-3" variant="warning" />
  )
}

export default LoadingIndicator;